module.exports = __webpack_public_path__ + "img/arrow-down-to-line.a59058f6.svg";